import React, { useState, useEffect } from "react";
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/react';
import { collection, getDocs } from "firebase/firestore";
import { db } from  "../../services/firebase";
import { motion } from 'framer-motion';
import { getAuth } from "firebase/auth";
import { ReactComponent as EventIcon } from '../../assets/icons/EventIcon.svg';
import { ReactComponent as ClientesIcon } from '../../assets/icons/ClientesIcon.svg';
import { ReactComponent as TimeIcon } from '../../assets/icons/TimeIcon.svg';
import { ReactComponent as LocationIcon } from '../../assets/icons/LocationIcon.svg';
import { formatearFechaInput, isoAFechaDisplay, fechaDisplayAIso } from '../../services/fechas';

const CreateEventSideBar = ({ isVisible, onClose, onEventCreated, prefilledEvent, prefilledDateTime }) => {
  const [formData, setFormData] = useState({
    title: prefilledEvent?.title || "",
    description: prefilledEvent?.description || "",
    date: prefilledEvent
      ? isoAFechaDisplay(prefilledEvent.date)
      : prefilledDateTime
      ? isoAFechaDisplay(prefilledDateTime.date.toISOString().split('T')[0])
      : "",
    location: prefilledEvent?.location || "",
    startTime: prefilledEvent
      ? `${String(prefilledEvent.startHour).padStart(2,'0')}:${String(prefilledEvent.startMinutes).padStart(2,'0')}`
      : prefilledDateTime
      ? `${String(prefilledDateTime.startTime.getHours()).padStart(2,'0')}:00`
      : "",
    endTime: prefilledEvent
      ? `${String(prefilledEvent.endHour).padStart(2,'0')}:${String(prefilledEvent.endMinutes).padStart(2,'0')}`
      : prefilledDateTime
      ? `${String(prefilledDateTime.endTime.getHours()).padStart(2,'0')}:00`
      : "",
    allDay: false,
    personas: prefilledEvent?.personas.map((p) => ({ nombreCompleto: p })) || [],
  });
const [usuarios, setUsuarios] = useState([]);
const auth = getAuth();
const currentUser = auth.currentUser;
useEffect(() => {
const fetchUsuarios = async () => {
const usuariosCol = collection(db, "usuarios");
const usuariosSnapshot = await getDocs(usuariosCol);
let usuariosList = usuariosSnapshot.docs.map((doc) => {
const data = doc.data();
return {
uid: doc.id,
nombre: data.nombre,
apellido: data.apellido,
nombreCompleto: `${data.nombre} ${data.apellido}`,
};
});
if (currentUser) {
usuariosList = usuariosList.filter(
(usuario) => usuario.uid !== currentUser.uid
);
}
setUsuarios(usuariosList);
};
fetchUsuarios();
}, [currentUser]);
const handleChange = (e) => {
const { name, value } = e.target;
setFormData((prev) => ({ ...prev, [name]: name === 'date' ? formatearFechaInput(value) : value }));
};
const handleTimeChange = (e) => {
let { name, value } = e.target;
value = value.replace(/\D/g, "");
if (value.length > 4) value = value.slice(0, 4);
if (value.length >= 3) value = value.slice(0, 2) + ":" + value.slice(2);
setFormData((prev) => ({ ...prev, [name]: value }));
};
const handleAllDayChange = (e) => {
const checked = e.target.checked;
setFormData((prev) => ({
...prev,
allDay: checked,
startTime: checked ? "00:00" : "",
endTime: checked ? "23:59" : "",
}));
};
const handlePersonasChange = (selectedUser) => {
setFormData((prev) => {
const exists = prev.personas.find((p) => p.uid === selectedUser.uid);
if (exists) {
return {
...prev,
personas: prev.personas.filter((p) => p.uid !== selectedUser.uid),
};
} else {
return { ...prev, personas: [...prev.personas, selectedUser] };
}
});
};

const handleSubmit = async (e) => {
  e.preventDefault();
  
  const [startHour, startMinutes] = formData.startTime.split(":").map(Number);
  const [endHour, endMinutes] = formData.endTime.split(":").map(Number);
 
  // Asegúrate de que el usuario actual exista antes de continuar
  if (!currentUser) {
    console.error("No hay usuario autenticado.");
    return;
  }

  const fechaIso = fechaDisplayAIso(formData.date);
  if (!fechaIso) {
    alert('La fecha no es válida. Usá el formato dd/mm/aaaa.');
    return;
  }

  const payload = {
    ...formData,
    date: fechaIso,
    startHour,
    startMinutes,
    endHour,
    endMinutes,
    personas: formData.personas.map((p) => p.nombreCompleto),
    creadorId: currentUser.uid, // Agrega el ID del usuario actual
  };

  try {
    const url = prefilledEvent ? `https://backend-288175208699.europe-west1.run.app/actualizar-calendar/${prefilledEvent.id}` : "https://backend-288175208699.europe-west1.run.app/crear-calendar";
    const method = prefilledEvent ? "PUT" : "POST";

    const idToken = await currentUser.getIdToken();
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
      body: JSON.stringify(payload),
    });
    const data = await res.json();

    if (prefilledEvent && onEventCreated) {
      // 🔹 Devuelve el evento actualizado al padre
      onEventCreated({ ...payload, id: prefilledEvent.id });
    }
    onEventCreated();
    onClose();
  } catch (err) {
    console.error("Error:", err);
  }
};

const isFormValid = () => {
  return (
    formData.title.trim() !== "" &&
    formData.date.trim() !== "" &&
    formData.startTime.trim() !== "" &&
    formData.location.trim() !== ""
  );
};
const sidebarClass = `create-event-sidebar ${isVisible ? "visible" : ""}`;
return (
<motion.div
 initial={{ y: "100%" }}
  animate={{ y: 0 }}
  exit={{ y: "100%" }} 
  transition={{ duration: 0.25, ease: "easeInOut" }}
  className={sidebarClass}
  style={{
    position: "absolute",
    width: "100%",
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    zIndex: 50, 
    height:'95%',
    bottom:'0',
    background: "#fff",
    boxShadow: "0 -4px 20px rgba(0,0,0,0.2)",
  }}
>
<div className="sidebar-header" style={{backgroundColor:'transparent',margin:'0 auto 0 0',padding:'10px 0px 5px', width:'90%',margin:'0 auto 15px', border:'none'}}>
<div className="sidebar-close-button" style={{marginLeft:'auto', fontSize:'30px',lineHeight:'20px'}} onClick={onClose}>&times;</div>
</div>
<div className="sidebar-header" style={{backgroundColor:'transparent',margin:'0',padding:'5px 0px 10px', width:'85%',margin:'0 auto 15px', borderBottom: '1px solid #eaeef5', marginBottom:'10px'}}>

       <input
          type="text"
          name="title"
          placeholder="Agregar título"
          value={formData.title}
          onChange={handleChange}
          className="sidebar-header-title"
        />

        </div>
<form onSubmit={handleSubmit} className="calendar-sidebar-form">
<div style={{display:'flex',flexDirection:'row',  gap:'15px',}} >
<TimeIcon className="sidebar-search-icon" style={{marginTop:'10px'}}/>
<div style={{display:'flex',flexDirection:'column', width:'100%', gap:'15px',}} >
<input
  type="text"
  inputMode="numeric"
  name="date"
  placeholder="dd/mm/aaaa"
  style={{width:'65%'}}
  onChange={handleChange}
  value={formData.date}
  className="calendar-sidebar-input calendar-sidebar-input-date"
/>
<div style={{display:'flex',flexDirection:'row', width:'65%', gap:'15px',alignContent:'center',alignItems:'center'}} >
<input
type="text"
name="startTime"
placeholder="HH:MM"
value={formData.startTime}
onChange={handleTimeChange}
disabled={formData.allDay}
style={{textAlign:'center'}}
className="calendar-sidebar-input calendar-sidebar-input-time"
/>-
<input
type="text"
name="endTime"
placeholder="HH:MM"
value={formData.endTime}
onChange={handleTimeChange}
disabled={formData.allDay}
style={{textAlign:'center'}}
className="calendar-sidebar-input calendar-sidebar-input-time"
/></div>
<label className="calendar-sidebar-checkbox-label">
<input
type="checkbox"
checked={formData.allDay}
onChange={handleAllDayChange}
className="calendar-sidebar-checkbox"
/>{" "}
Todo el día
</label>
</div>
</div>
<div style={{ display: 'flex', flexDirection: 'row', gap: '15px', position: 'relative' }}>
<ClientesIcon className="sidebar-search-icon" style={{ marginTop: '10px' }} />
<Listbox value={formData.personas} onChange={handlePersonasChange}>
{({ open }) => (
<>
<ListboxButton className={`calendar-sidebar-listbox-button ${open ? "open" : ""}`}>
{formData.personas.length > 0
? formData.personas.map((p) => p.nombreCompleto).join(", ")
: "Agregar personas"}
<span className="calendar-sidebar-listbox-arrow-container">
<span className="calendar-sidebar-listbox-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="calendar-sidebar-listbox-options">
{usuarios.map((usuario) => (
<ListboxOption
key={usuario.uid}
value={usuario}
className="calendar-sidebar-listbox-option"
>
{usuario.nombreCompleto}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div style={{display:'flex',flexDirection:'row', gap:'15px'}} >
<LocationIcon className="sidebar-search-icon" style={{marginTop:'10px'}}/>
<input
type="text"
name="location"
value={formData.location}
placeholder="Agregar ubicación"
onChange={handleChange}
className="calendar-sidebar-input calendar-sidebar-input-location"
/>
</div>
<div style={{display:'flex',flexDirection:'row',  gap:'15px'}} >
<EventIcon className="sidebar-search-icon" style={{marginTop:'10px'}}/>
  <textarea
    name="description"
    placeholder="Agregar descripción"
    value={formData.description}
    onChange={handleChange}
    className="calendar-sidebar-input calendar-sidebar-input-description"
    rows={6} 
    style={{fontFamily:'Effra',fontWeight:'normal', resize: "none", width: "100%",color:'#454746' }} 
  />
</div>
<button
  type="submit"
  className="button"
  style={{ width: 'fit-content', fontSize: '14px', marginTop: '20px' }}
  disabled={!isFormValid()}
>
  Guardar
</button>
</form>
</motion.div>
);
};
export default CreateEventSideBar;
